<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="typeForm"
               :rules="typeRules"
               ref="typeForm"
               label-width="80px"
               class="type-form">
        <el-form-item label="区域："
                      prop="area_id">
          <el-select v-model="typeForm.area_id"
                     placeholder="请选择区域"
                     @change="handleRoomChange">
            <el-option v-for="item in roomList"
                       :key="item.id"
                       :disabled="item.area_type === 'area_type_no'"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备："
                      prop="lock_id">
          <el-select v-model="typeForm.lock_id"
                     placeholder="请选择设备">
            <el-option v-for="item in typeList"
                       :key="item.lock_id"
                       :label="item.lock_name"
                       :value="item.lock_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间组："
                      prop="slot_id">
          <el-select v-model="typeForm.slot_id"
                     placeholder="请选择时间组">
            <el-option v-for="item in timeList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/pass_rule/add' || '/pass_rule/edit'"
                 type="primary"
                 @click="handleConfirm('typeForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加规则' : '编辑规则'
    }
  },
  data() {
    return {
      showModal: this.isShow,
      typeForm: {
        area_id: '',
        lock_id: '',
        slot_id: ''
      },
      typeRules: {
        area_id: [{ required: true, message: '请选择区域' }],
        lock_id: [{ required: true, message: '请选择设备' }],
        slot_id: [{ required: true, message: '请选择时间组' }]
      },
      roomList: [],
      typeList: [],
      timeList: [],
      tmpArr: []
    }
  },
  created() {
    this.getAreaList()
    this.getTimeList()
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取数据
    getAreaList() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取设备列表
    roomLockList(val) {
      fetch.roomLockList({ area_id: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取列表
    getTimeList() {
      fetch.getTimeList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.timeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取编辑信息
    getInfo() {
      fetch.getPassRuleInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeForm = data
            this.roomLockList(data.area_id)
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleRoomChange(val) {
      this.typeForm.lock_id = ''
      this.roomLockList(val)
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addPassRule({ ...this.typeForm, group_id: this.data.pId }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editPassRule({ ...this.typeForm, group_id: this.data.pId }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
